import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Download, FileText } from 'lucide-react';

export const TierPDFCard = ({ pdf }) => (
    <Card className="h-full bg-card border-border card-lift" data-testid={`pdf-card-${pdf.id}`}>
        <CardContent className="p-5">
            <div className="flex items-start gap-3">
                <div className="h-11 w-11 rounded-lg bg-[hsl(var(--primary))]/10 text-[hsl(var(--primary))] flex items-center justify-center shrink-0">
                    <FileText className="h-5 w-5" />
                </div>
                <div className="min-w-0 flex-1">
                    <div className="font-semibold text-sm leading-snug mb-1">
                        {pdf.title}
                    </div>
                    {pdf.description && (
                        <div className="text-xs text-muted-foreground leading-relaxed line-clamp-2">
                            {pdf.description}
                        </div>
                    )}
                    <div className="mt-3 flex items-center justify-between gap-2">
                        {pdf.file_size && (
                            <span className="text-[10px] text-muted-foreground">
                                {pdf.file_size}
                            </span>
                        )}
                        <a
                            href={pdf.file_url}
                            target="_blank"
                            rel="noreferrer noopener"
                            data-testid={`pdf-download-${pdf.id}`}
                        >
                            <Button
                                size="sm"
                                variant="outline"
                                className="border-[hsl(var(--primary))]/25 text-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/5"
                            >
                                <Download className="h-3.5 w-3.5 mr-1.5" />
                                Download PDF
                            </Button>
                        </a>
                    </div>
                </div>
            </div>
        </CardContent>
    </Card>
);

export default TierPDFCard;
